import React from 'react';
import { ButtonGroup, ToggleButton } from '@applyboard/ui-components';
import { TableOutlineIcon, ColumnsOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
export var ColumnTableToggleButtonGroup = function ColumnTableToggleButtonGroup(_ref) {
  var isTableView = _ref.isTableView;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var onClick = function onClick() {
    var toPath = isTableView ? '/leads' : '/students';
    trackEvent({
      event: 'Leads - Clicked To Toggle Between Views',
      group: 'Lead Management Tool',
      data: {
        'What view was selected?': toPath
      }
    });
    global.window.localStorage.setItem('session_crm_preference', toPath);
    // Because routing depends on localStorage, we have to completely reload and can't use react-router-dom
    global.window.location.href = toPath;
  };
  return /*#__PURE__*/React.createElement(ButtonGroup, {
    position: "center",
    size: "small"
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    "data-testid": "toggle-button-columns",
    hideLabel: true,
    isActive: !isTableView,
    icon: ColumnsOutlineIcon,
    outline: true,
    onClick: onClick
  }), /*#__PURE__*/React.createElement(ToggleButton, {
    "data-testid": "toggle-button-tables",
    hideLabel: true,
    isActive: isTableView,
    icon: TableOutlineIcon,
    outline: true,
    onClick: onClick
  }));
};